import { useContext } from 'react'

import { Box } from '@material-ui/core'
// @ts-expect-error - NEED TO TYPE??
import { ContentItemCard, Event } from '@scoir/college-content'

import ContentModalContext from '../../ContentModalProvider/Context'

const CardPreview = () => {
  const { item, type } = useContext(ContentModalContext)

  return (
    <Box mx={'15%'}>
      <ContentItemCard
        key={item.Id}
        id={item.Id}
        type={type}
        scid={item.Scid}
        title={item.Title}
        contentImgAlt={item.AltText || item.Title}
        description={item.Description}
        url={item?.Link}
        imageUrl={item.ImageUrl}
        tags={item.Tags}
        foci={item.AcademicFocus}
        showContentEmptyState
        collegeEvent={
          <Event
            item={item}
            stackSegments
          />
        }
      />
    </Box>
  )
}

export default CardPreview
